export const SOCKET_PATH = '/realtime';
/** How often the server pushes a timer tick (ms). */
export const TIMER_TICK_MS = 15_000;
/** How often the client flushes avatar movement to the server (ms). */
export const MOVE_FLUSH_MS = 80;
/** How often the server broadcasts batched positions (ms) — keeps FR-2.3 under 150ms. */
export const POSITION_BROADCAST_MS = 100;
//# sourceMappingURL=socket.js.map